export default function SocialProof() {
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 sm:mb-8 leading-tight">
          Resultados vêm de método, não de promessas
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
          Cada projeto é tratado de forma estratégica, respeitando o estágio do negócio, seus objetivos e sua capacidade de crescimento sustentável.
        </p>
      </div>
    </section>
  );
}
